module.exports = __webpack_public_path__ + "media/images/icon-company-plan-f2d30bc4498dd9b7e2c25e98d4422567.svg";